import Stack from '@mui/material/Stack';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider, Dialog, Floating } from 'components';
import { codelists } from 'constants/codelists';
import contactTake from 'features/views/contactTake';

import ActionButtons from './components/ActionButtons';
import Filter from './components/Filter';
import Table from './components/Table';

export const ContactTakeModalBody = () => (
	<Stack spacing={5}>
		<Floating>
			<Dialog name={contactTake.constants.dialogError} mui flex>
				{getLabelMessage('common:requiredFields')}
				<ul>
					<li>{getLabelMessage('contactTake:minCombination1')}</li>
					<li>{getLabelMessage('contactTake:minCombination2')}</li>
					<li>{getLabelMessage('contactTake:minCombination3')}</li>
					<li>{getLabelMessage('contactTake:minCombination4')}</li>
				</ul>
			</Dialog>
		</Floating>
		<Filter />
		<Table />
		<ActionButtons />
	</Stack>
);

export default codelistProvider(codelists.solutionState, 'contactStatesCodelist')(ContactTakeModalBody);
